export type Project = {
  industry: string
  type: 'Custom build' | 'Redesign' | 'Ecommerce' | 'Integration'
  scope: string
  outcome: string
  accent: 'orange' | 'green' | 'cyan' | 'blue'
  layout: 'catalog' | 'gallery' | 'schedule' | 'booking' | 'listings' | 'specs' | 'intake' | 'store' | 'membership'
}

export const projects: Project[] = [
  {
    industry: 'Apparel & printing',
    type: 'Ecommerce',
    scope: 'Online store, artwork uploads, custom order forms',
    outcome: 'Custom orders arrive with artwork and specs attached instead of a phone call.',
    accent: 'orange',
    layout: 'catalog',
  },
  {
    industry: 'Bathroom remodeling',
    type: 'Redesign',
    scope: 'Project galleries, quote requests, service area pages',
    outcome: 'Finished work leads the site, and each service area has a page worth ranking.',
    accent: 'cyan',
    layout: 'gallery',
  },
  {
    industry: 'Martial arts',
    type: 'Custom build',
    scope: 'Class schedule, trial signups, membership pages',
    outcome: 'Parents can see the schedule and book a trial class without calling first.',
    accent: 'green',
    layout: 'schedule',
  },
  {
    industry: 'Auto service',
    type: 'Custom build',
    scope: 'Appointment booking, service menu, local structure',
    outcome: 'Bookings come in overnight and land straight in the shop calendar.',
    accent: 'blue',
    layout: 'booking',
  },
  {
    industry: 'Marine',
    type: 'Integration',
    scope: 'Inventory listings, parts enquiries, seasonal service',
    outcome: 'Listings stay accurate because inventory syncs instead of being retyped.',
    accent: 'cyan',
    layout: 'listings',
  },
  {
    industry: 'Industrial',
    type: 'Custom build',
    scope: 'Capability pages, spec library, RFQ workflow',
    outcome: 'Engineers download the spec sheet themselves and send a qualified RFQ.',
    accent: 'orange',
    layout: 'specs',
  },
  {
    industry: 'Chiropractic',
    type: 'Redesign',
    scope: 'New patient intake, provider pages, online booking',
    outcome: 'Paperwork is done before the patient reaches the front desk.',
    accent: 'green',
    layout: 'intake',
  },
  {
    industry: 'Retail & ecommerce',
    type: 'Ecommerce',
    scope: 'Catalog build, 0% transaction fees, inventory API',
    outcome: 'Margin stays with the business as order volume grows.',
    accent: 'orange',
    layout: 'store',
  },
  {
    industry: 'Fitness',
    type: 'Custom build',
    scope: 'Memberships, trainer profiles, schedule integration',
    outcome: 'Signups and class times run from one place the staff can edit.',
    accent: 'blue',
    layout: 'membership',
  },
]
